export const statusCodes = {
  //is-owner-and-esim-eligible
  //is-owner-and-esim-eligible-with-filtered-campaign
  //is-owner-and-esim-eligible-with-expired-campaign
  //is-owner-and-esim-eligible-with-campaign
  //is-owner-and-esim-eligible-included-in-subscription
  //is-owner-and-esim-eligible-chub-order-exception
  //is-owner-and-esim-eligible-both-subscribed
  isEligible: 'isEligible',

  isNotEligible: 'isNotEligible',

  isNotOwner: 'isNotOwner',

  //is-owner-and-not-esim-eligible
  isOwnerAndNotEsimEligible: 'isOwnerAndNotEsimEligible',

  //is-owner-and-esim-eligible-with-one-already-subscribed
  //is-owner-and-esim-eligible-has-open-chub-order
  isEligibleButAllSubscribed: 'isEligibleButAllSubscribed',

  //is-owner-and-esim-eligible-open-order
  //is-owner-and-esim-eligible-open-order-long-running
  isEligibleHasOpenOrder: 'isEligibleHasOpenOrder',

  //is-owner-and-esim-eligible-expired-order
  //is-owner-and-esim-eligible-unknown-chub-order-exception
  isEligibleHasExpiredOrder: 'isEligibleHasExpiredOrder',

  //is-owner-and-esim-eligible-has-product-with-eid
  isEligibleButHasProductWithEid: 'isEligibleButHasProductWithEid',

  unknown: 'unknown',
};

export type SmartWearStatusCode = keyof typeof statusCodes;

export const smartWearOrderVerificationStatus = {
  NotOrdered: 'NotOrdered',
  Pending: 'Pending',
  Provisioned: 'Provisioned',
};
export type SmartWearOrderVerificationStatus = keyof typeof smartWearOrderVerificationStatus;
